<!--
 * @Author: lijiahui
 * @Date: 2020-06-04 09:49:07
 * @LastEditTime: 2022-07-29 16:48:54
 * @LastEditors: xuhuining
 * @Description: 回复详情页
 * @FilePath: /xingmahui_front/src/views/common/replyComment.vue
-->

<template>
  <div class="wrap">
    <Back @goBack="goBack">
      <div slot="header">
        <div class="back" @click.stop="goBack">
          <van-icon name="arrow-left" size="20"/>
        </div>
      </div>
    </Back>

    <!-- 一级评论-->
    <div class="firstComment">
      <span
          v-lazy:background-image="firstComList.headImg"
          class="commentAvatars"
      ></span>
      <span class="commentName"
      >{{
          firstComList.nickName
        }}<span
            v-if="userInfo != null && firstComList.crmId == userInfo.crm_id"
            class="myComment"
        >我的评论</span
        ></span
      >
      <div
          ref="fitstComment"
          class="commentText"
          @click="replyComment(firstComList, '1')"
      >
        <div class="con2" v-text="firstComList.contents"></div>
        <!-- 图片组件 -->
        <picture-group
            v-if="firstComList.commentImgs"
            :foodImg="firstComList.commentImgs"
        ></picture-group>
        <!-- <span class="expand openCon2">... <span @click="expandComment($event,3)">展开</span></span> -->
        <!-- <p class="expand closeCon2" @click="expandComment($event,4)"><span>收起</span></p> -->
      </div>
      <div class="bottom">
        <span class="time"
        >{{
            firstComList.time
          }}<span
              v-if="userInfo != null && firstComList.crmId == userInfo.crm_id"
              class="delete"
              @click="dialogToast(firstComList, '1')"
          >删除</span
          ></span
        >
        <span class="box">
          <span
              class="commentLike"
              @click="
              support(
                firstComList.index,
                '2',
                firstComList.id,
                firstComList.crmId,
                firstComList.id
              )
            "
          >
            <van-icon
                v-if="!firstComList.isLikes"
                color="#999"
                name="good-job-o"
            />
            <van-icon v-else color="#D7AB3A" name="good-job"/>
            <span v-if="firstComList.likes != 0">{{
                fomatterNum(firstComList.likes)
              }}</span>
          </span>
          <span class="commentBox" @click="replyComment(firstComList, '1')">
            <img alt="" src="./../../assets/images/baby/icon1.png"/>
          </span>
        </span>
      </div>
    </div>
    <!-- 二级回复列表 -->
    <div v-if="firstComList.pageBean != null" class="secondCommentList">
      <div class="title">共{{ firstComList.pageBean.totalElements }}条回复</div>
      <van-list
          v-model="listLoading"
          :error.sync="listError"
          :finished="listFinished"
          :finished-text="finishText"
          class="vanlist"
          error-text="请求失败，点击重新加载"
          @load="getAllComment()"
      >
        <div
            v-for="(item, index) in commentAllList"
            :key="item.id"
            class="commentList"
        >
          <span
              v-lazy:background-image="
              item.crmId != '0' ? item.headImg : gmHeadImg
            "
              class="commentAvatars"
          ></span>
          <span class="commentName"
          ><span :style="item.crmId == '0' ? 'color:#8A9EF3' : ''">{{
              item.nickName
            }}</span
          ><img src="./../../assets/images/baby/icon4.png"/><span
              :style="item.replyCrmId == '0' ? 'color:#8A9EF3' : ''"
          >{{ item.replyNickName }}</span
          ></span
          >
          <div
              ref="commentList"
              class="commentText"
              @click="replyComment(item, '2')"
          >
            <div class="con" v-text="item.contents"></div>
            <!-- <span class="expand openCon">... <span @click="expandComment($event,1)">展开</span></span> -->
            <!-- <p class="expand closeCon" @click="expandComment($event,2)"><span>收起</span></p> -->
          </div>
          <div class="bottom">
            <span class="time"
            >{{
                item.time
              }}<span
                  v-if="userInfo != null && item.crmId == userInfo.crm_id"
                  class="delete"
                  @click="dialogToast(item, '2')"
              >删除</span
              ></span
            >
            <span class="box">
              <span
                  class="commentLike"
                  @click="
                  secondSupport(index, '3', item.parentId, item.crmId, item.id)
                "
              >
                <van-icon v-if="!item.isLikes" color="#999" name="good-job-o"/>
                <van-icon v-else color="#D7AB3A" name="good-job"/>
                <span v-if="item.likes != 0">{{
                    fomatterNum(item.likes)
                  }}</span>
              </span>
              <span class="commentBox" @click="replyComment(item, '2')">
                <img alt="" src="./../../assets/images/baby/icon1.png"/>
              </span>
            </span>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 评论输入框 -->
    <div v-show="isFocus" class="centerComment" @click="isBlur()">
      <div
          class="mask"
          @click="isBlur('1')"
          @touchmove.prevent
          @mousewheel.prevent
      ></div>
      <div class="fieldWrap">
        <div class="fieldCon">
          <van-cell-group class="input-item">
            <van-field
                v-model="message"
                :autosize="{ maxHeight: 170 }"
                :placeholder="'回复：' + replyNames"
                autofocus
                maxlength="200"
                rows="10"
                type="textarea"
                @input="inputChange"
            />
          </van-cell-group>
        </div>
        <div class="fieldTop">
          <!-- <span class="close" @click="isBlur('1')"><img src="./../../assets/images/activity/harvard/close.png" alt=""></span> -->
          <!-- <span class="title">回复：{{replyNames}}</span> -->
          <span
              class="button"
              @click="message.length > 0 ? submitAllComment() : ''"
          >提交</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import './../../assets/less/harvard.less';

.wrap {
  min-height: 100%;
  background: #fff;
}

.back {
  padding-top: 19px;
  width: 22px;
  padding-left: 5px;
}

.goback {
  z-index: 100;
  width: 26px;
  position: fixed;
  top: 7px;
  left: 7px;

  img {
    width: 26px;
    height: 26px;
  }
}

.firstComment {
  padding: 15px 0;
  margin: 0 12px;
  // border-bottom: 10px solid #F2F2F2;
  .commentAvatars {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: inline-block;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    float: left;
  }

  .commentName {
    padding-left: 11px;
    color: #999;
    font-size: 14px;

    .myComment {
      background: #fff8f0;
      color: #d7ab3a;
      font-size: 12px;
      text-align: center;
      padding: 4px 7px;
      margin-left: 5px;
    }
  }

  .commentText {
    padding-top: 10px;
    padding-left: 10px;
    line-height: 20px;
    overflow: hidden;
    // max-height: 60px;
    font-size: 14px;
    color: #333;
    font-weight: 400;
    position: relative;
    word-wrap: break-word;
    word-break: break-all;
    text-overflow: ellipsis;

    .con {
      word-break: break-word;
      white-space: pre-wrap;
    }

    .expand {
      color: @color51;
      font-size: @fontSize14;
      line-height: 22px;
      display: none;
      position: absolute;
      bottom: 0px;
      right: 9px;
      background: #fff;

      span {
        color: #8fa2f3;
      }
    }

    .closeCon {
      width: 100%;
      text-align: right;
      position: inherit;
    }
  }

  .bottom {
    padding-top: 10px;

    .time {
      color: #999;
      font-size: 11px;
      padding-left: 44px;

      .delete {
        color: #999;
        font-size: 11px;
        padding-left: 14px;
      }
    }

    .box {
      line-height: 20px;
      float: right;

      .commentLike {
        display: inline-block;
        width: 60px;

        .van-icon {
          font-size: 16px;
          margin-top: 2px;
          vertical-align: middle;
        }

        span {
          color: #999;
          display: inline-block;
          //   height: 20px;
          vertical-align: bottom;
          margin-left: 3px;
          line-height: 1;
        }
      }

      .commentBox {
        margin-right: 20px;

        img {
          width: 15px;
          height: 15px;
          vertical-align: middle;
        }
      }
    }
  }
}

.secondCommentList {
  border-top: 10px solid #f2f2f2;

  .title {
    color: #999;
    font-size: 12px;
    padding: 15px 0 14px 10px;
    border-bottom: 1px solid #f2f2f2;
  }

  .commentList {
    margin: 0 12px;
    padding: 15px 0;
    border-bottom: 1px solid #f2f2f2;
    word-wrap: break-word;
    word-break: break-all;
    text-overflow: ellipsis;

    .commentAvatars {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      display: inline-block;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
      float: left;
    }

    .commentName {
      padding-left: 11px;
      color: #999;
      font-size: 14px;

      .myComment {
        background: #fff8f0;
        color: #d7ab3a;
        font-size: 12px;
        text-align: center;
        padding: 4px 7px;
        margin-left: 5px;
      }

      img {
        width: 12px;
        height: 9px;
        padding: 0 6px;
      }
    }

    .commentText {
      padding-top: 10px;
      padding-left: 10px;
      line-height: 22px;
      overflow: hidden;
      // max-height: 63px;
      font-size: 14px;
      color: #333;
      font-weight: 400;
      position: relative;
      word-wrap: break-word;
      word-break: break-all;
      text-overflow: ellipsis;

      .con {
        word-break: break-word;
        white-space: pre-wrap;
      }

      .expand {
        color: @color51;
        font-size: @fontSize14;
        line-height: 22px;
        display: none;
        position: absolute;
        bottom: 1px;
        right: 11px;
        background: #fff;

        span {
          color: #8fa2f3;
        }
      }

      .closeCon {
        width: 100%;
        text-align: right;
        position: inherit;
      }
    }

    .bottom {
      padding-top: 10px;

      .time {
        color: #999;
        font-size: 11px;
        padding-left: 44px;

        .delete {
          color: #999;
          font-size: 11px;
          padding-left: 14px;
        }
      }

      .box {
        float: right;

        .commentLike {
          display: inline-block;
          width: 63px;
          height: 12px;
          // padding-right: 36px;
          .van-icon {
            font-size: 16px;
            // margin-top: 1px;
            vertical-align: middle;
          }

          span {
            color: #999;
            display: inline-block;
            // height: 12px;
            margin-left: 3px;
            vertical-align: bottom;
            line-height: 1;
          }
        }

        .commentBox {
          margin-right: 20px;

          img {
            width: 15px;
            height: 15px;
            vertical-align: bottom;
            // vertical-align: text-bottom;
          }
        }
      }
    }
  }
}

.centerComment {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: @expertColorMask;
  z-index: 1000;

  .mask {
    min-height: 70%;
  }

  .fieldWrap {
    background: rgba(255, 255, 255, 1);
    border-radius: 8px 8px 0 0;
    width: 100%;
    // height: 224px;
    position: fixed;
    bottom: 0;
    left: 0;

    .fieldTop {
      padding: 11px 0;
      // display: flex;
      // justify-content: space-between;
      overflow: hidden;

      .close {
        padding-left: 15px;
        padding-top: 5px;

        img {
          width: 12px;
          height: 12px;
        }
      }

      .title {
        text-align: center;
        color: #333;
        font-size: 16px;
        font-weight: 500;
        padding-left: 25px;
      }

      .button {
        width: 47px;
        height: 26px;
        background: #e2e2e2;
        border-radius: 4px;
        text-align: center;
        line-height: 26px;
        color: #a8a8a8;
        font-size: 12px;
        margin-right: 15px;
        float: right;
      }

      .button2 {
        background: linear-gradient(270deg,
        rgba(215, 168, 92, 1) 0%,
        rgba(231, 196, 121, 1) 100%);
        color: #fff;
      }
    }

    .fieldCon {
      padding: 15px 16px 0;

      .input-item > div {
        width: 100%;
        font-size: @fontSize14;
        min-height: 18px;
        margin-right: auto;
        line-height: 18px;
        color: #333333;
        word-wrap: break-word;
        // overflow-x: hidden;
        // overflow-y: auto;
        -webkit-user-select: text;
        outline: none;
        box-sizing: border-box;
        max-height: 170px;
        padding: 0;
      }

      /deep/ .van-field__control {
        caret-color: #8489ff;
        padding: 10px 0 5px;
        // overflow: scroll;
      }

      .input-item::-webkit-scrollbar {
        width: 0px;
      }

      .van-hairline--top-bottom::after {
        border: 0px;
      }
    }
  }
}

/deep/ .van-list__finished-text {
  background: #fff;
}
</style>

<script>
import pictureGroup from '../contents/foodColumn/component/pictureGroup'
import Back from '@/components/common/goBack'
import {Debounce, fomatterNum, getCookie, getHeadImgAndName, globalGoLogin, setCookie,} from '@/assets/js/common.js'

export default {
  data() {
    return {
      listLoading: false,
      listFinished: false,
      listError: false,
      finishText: '',
      commentAllList: [],
      curVideoId: '',
      isFocus: false,
      message: '', //评论内容
      replyUserInfo: [], // 回复用户信息
      carrierId: this.$route.query.type, // 类型 哈佛视频或奶娃百科 1 2
      articalId: this.$route.query.carrierSpecificId, // 具体文章id或视频id
      firstComment: this.$route.query.first, // 一级评论id
      currentComment: [], // 当前评论
      replyNames: '',
      isGoLogin: false,
      userInfo: [],
      commentParams: {
        page: 1,
        size: 25,
      },
      commentLen: 0, //评论列表当前数量
      oneConH: 22, //375屏幕下一行评论的高度
      commentTotal: '',
      firstComList: [], // 一级评论
      commentType: '',
      firstFlag: false, //以及评论点赞开关
      secondFlag: false, //二级评论点赞开关
      gmHeadImg: require('./../../assets/images/home/gmHeadImg.png'),
      itemSetId: '',
      sceneId: '',
      requestId: '',
    }
  },
  components: {
    Back,
    pictureGroup,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
          localStorage.getItem('userInfo') != null &&
          localStorage.getItem('userInfo') != '' &&
          JSON.parse(localStorage.getItem('userInfo')).mobile != null &&
          JSON.parse(localStorage.getItem('userInfo')).mobile != ''
      ) {
        vm.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        vm.isGoLogin = true
      }
      for (var i = 0; i < vm.commentAllList.length; i++) {
        if (vm.commentAllList[i].id == vm.firstComment) {
          vm.currentComment = vm.commentAllList[i]
        }
      }
      vm.getUserName()
      // if ((!vm.getCookie("xmh_nickname") || vm.getCookie("xmh_nickname") == "") || (!vm.getCookie("xmh_headimgurl") || vm.getCookie("xmh_headimgurl") == "")) {
      //   vm.$http.get("/wechat/getUserInfoByOpenId", { openId: vm.getCookie("xmh_openid") }, res => {
      //     if (res.code === "200") {
      //       document.cookie = `xmh_headimgurl=${res.data.headimgurl}`;
      //       document.cookie = 'xmh_nickname=' + escape(res.data.nickname);
      //     }
      //   });
      // }
    })
  },
  beforeRouteLeave(to, from, next) {
    this.scrollWatch = false
    window.removeEventListener('scroll', this.handleScroll)
    next()
  },
  mounted() {
    this.getAllComment()
    var path
    if (this.carrierId == '1') {
      path = '/harvard/' + this.articalId
    } else if (this.carrierId == '2') {
      path = '/baby/detail/' + this.articalId
    }
    var shareDataParams = {
      shareLink: this.$http.hostName + path,
      shareDesc: '1000万中国家庭都在看！科学育儿，全程陪伴，源于母爱。',
      shareTitle: '星妈会',
      imgUrl: 'https://image-mom.feihe.com/wxshare/home.png', //必须是绝对路径
    }
    this.wxJsSet.wxShare('fx', shareDataParams, this)
    window.addEventListener('scroll', this.handleScroll)
    var date = Date.parse(new Date())
    var id = this.getCookie('xmh_unionid')
    this.requestId = this.$md5(date + id)
    if (this.$http.hostName == 'https://mom.feihe.com') {
      // 正式环境物料id和服务id
      this.itemSetId = '16'
      this.sceneId = '41'
    } else {
      // uat环境物料id和服务id
      this.itemSetId = '12'
      this.sceneId = '296'
    }
  },

  methods: {
    fomatterNum,
    getCookie,
    setCookie,
    getUserName: async function () {
      try {
        const {headImgurl, nickName} = await getHeadImgAndName()
        this.setCookie('xmh_headimgurl', headImgurl, 365)
        this.setCookie('xmh_nickname', nickName, 365)
      } catch (err) {
      }
    },
    handleScroll() {
      this.scroll =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
      let top1 = $('.wrap').offset().top
      let top2 = $(document).scrollTop()
      let top = top1 - top2
      if (this.scroll > top1) {
        let t1 = 0
        let t2 = 0
        let timer2 = null // 定时器
        document.onscroll = function () {
          clearTimeout(timer2)
          timer2 = setTimeout(isScrollEnd, 300)
          t1 = document.documentElement.scrollTop || document.body.scrollTop
        }

        function isScrollEnd() {
          t2 = document.documentElement.scrollTop || document.body.scrollTop
          var path
          if (t2 == t1) {
            path = require('./../../assets/images/icon/back1.png')
            $('.backimg').attr('src', path)
          } else {
            path = require('./../../assets/images/icon/back2.png')
            $('.backimg').attr('src', path)
          }
        }
      }
    },

    // 删除评论弹窗
    dialogToast(item, type) {
      this.$dialog
          .confirm({
            message: '是否删除评论',
            confirmButtonText: '确定',
          })
          .then(() => {
            this.deleteCom(item, type)
          })
          .catch(() => {
          })
    },
    // 返回上一页
    // goBack() {
    //   this.$router.go(-1)
    // },
    deleteCom(item, type) {
      this.$http.get(
          this.$http.harvardBaseURL + '/comment/deleteComment/ZBvOm0ocQSUykUX5',
          {id: item.id, crmId: this.userInfo.crm_id, type: type},
          (res) => {
            if (res.code == '200') {
              gio('track', 'comment_deletecomment', {page_name: '评论详情'})
              sensors.track('DeleteComment', {
                content_id: this.articalId,
                content_title: this.title,
                page_name: this.$route.meta.title,
                delete_comment_type: type == '1' ? '评论' : '回复',
              })
              var status = true
              var page = '1'
              var size = '25'

              if (type == '1') {
                this.goBack()
              } else {
                this.getAllComment(page, size, status)
              }
              // this.goBack()
            }
          }
      )
    },
    // 返回上一页
    goBack() {
      if (window.history.length > 1 && this.getCookie('fromPath')) {
        this.$router.go(-1)
      } else {
        this.$router.push('/baby')
      }
    },
    inputChange() {
      if (this.message.length >= 1) {
        gio('track', 'comment_writecomment', {page_name: '评论详情'})
        $('.button').addClass('button2')
      } else if (this.message.length == 0) {
        $('.button').removeClass('button2')
      }
    },
    // 提交评论
    submitAllComment: Debounce(function () {
      this.isFocus = false
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let headImg = this.getCookie('xmh_headimgurl')
      let nickName = this.getCookie('xmh_nickname')
      let openid = this.getCookie('xmh_openid')
      let date = Date.parse(new Date())
      let appkey = '10002'
      let appSecret = 'HDKumsH47xXUAymRkPgLQt9qL9Odjljk'
      let sign = this.$md5(
          appSecret +
          'timestamp' +
          date +
          'crmId' +
          this.userInfo.crm_id +
          appSecret
      ).toUpperCase()
      this.$http.post(
          this.$http.harvardBaseURL +
          '/comment/save/reply/ZBvOm0ocQSUykUX5?sign=' +
          sign +
          '&timestamp=' +
          date,
          {},
          {
            carrierId: this.carrierId,
            carrierSpecificId: this.articalId,
            contents: this.message,
            crmId: this.userInfo != null ? this.userInfo.crm_id : '',
            headImg: headImg,
            nickName: nickName,
            replyCrmId: this.replyUserInfo.crmId,
            replyNickName: this.replyUserInfo.nickName,
            replyHeadImg: this.replyUserInfo.headImg,
            commentType: this.commentType,
            commentId: this.replyUserInfo.id,
            parentId:
                this.commentType == '1'
                    ? this.replyUserInfo.id
                    : this.replyUserInfo.parentId,
            openid: openid,
            replyOpenId: this.replyUserInfo.openid,
          },
          (res) => {
            if (res.code == '200') {
              gio('track', 'comment_submitcomment', {page_name: '评论详情'})
              sensors.track('CommentReplySent', {
                is_official: this.replyUserInfo.crmId == '0' ? true : false,
                answer_id: this.replyUserInfo.crmId,
                content_id: this.articalId,
                content_title: this.title,
                page_name: this.$route.meta.title,
                itemSetId: this.itemSetId,
                sceneId: this.sceneId,
                context: '',
                requestId: this.requestId,
              })
              this.message = ''
              $('body').css('position', 'initial')
              $('body').css('overflow', '')
              var page = '1'
              var size = '25'
              var status = true
              $('.button').removeClass('button2')
              var relation =
                  this.carrierId == '1'
                      ? this.commentType == '1'
                          ? 'spfhyj' + this.replyUserInfo.id
                          : 'sphfej' + this.replyUserInfo.id
                      : this.commentType == '1'
                          ? 'wzhfyj' + this.replyUserInfo.id
                          : 'wzhfej' + this.replyUserInfo.id
              this.$toast({
                duration: 2000,
                message: '评论成功',
                context: this,
              })
              this.getAllComment(page, size, status)
            } else {
              this.$toast({
                duration: 2000,
                message: res.message,
                context: this,
              })
            }
          }
      )
    }, 500),
    isBlur(id) {
      if (id == '1') {
        gio('track', 'comment_closecomment', {page_name: '评论详情'})
        $('body').css('position', 'initial')
        $('body').css('overflow', '')
        this.isFocus = false
      } else if (id == '2') {
      } else if (id == '3') {
      }
    },
    // 回复
    replyComment: Debounce(function (item, type) {
      if (!this.isGoLogin) {
        globalGoLogin()
      } else {
        // if(type=='first'){ // 一级回复
        //     this.replyNames=item.name
        // }else{ // 二级回复
        //     this.replyNames=item.replyName
        // }
        gio('track', 'comment_replycomment', {page_name: '评论详情'})
        $('body').css('position', 'absolute')
        $('body').css('overflow', '')
        this.commentType = type
        this.replyNames = item.nickName
        this.replyUserInfo = item
        this.isFocus = true
        // 自动获取焦点
        this.$nextTick(() => {
          $('textarea')[0].focus()
        })
      }
    }, 500),
    //一级评论点赞与取消点赞
    support: function (index, type, parentId, replyCrmId, commentId) {
      if (!this.isGoLogin) {
        globalGoLogin()
      } else {
        if (this.firstFlag) return false
        this.firstFlag = true
        const {isLikes, likes, id} = this.firstComList
        let self = this
        if (isLikes) {
          sensors.track('Unsupport', {
            content_id: this.articalId,
            content_title: this.title,
            author: '',
            page_name: this.$route.meta.title,
            is_comment: true,
          })
          this.cancelLike(type, parentId, replyCrmId, commentId, function () {
            self.firstFlag = false
            self.firstComList.likes -= 1
            if (likes < 0) {
              self.firstComList.likes = 0
            }
            self.firstComList.isLikes = !isLikes
          })
        } else {
          // gio('track', 'hafovideopage_commentpopgreat',{'member_level':this.memberLevel.grade.name});
          gio('track', 'comment_likecomment', {page_name: '评论详情'})
          sensors.track('Support', {
            content_id: this.articalId,
            content_title: this.title,
            author: '',
            page_name: this.$route.meta.title,
            is_comment: true,
          })
          this.addLike(id, type, parentId, replyCrmId, commentId, function () {
            self.firstFlag = false
            self.firstComList.likes += 1
            self.firstComList.isLikes = !isLikes
            var relation =
                self.carrierId == '1'
                    ? type == '2'
                        ? 'spyjdz' + commentId
                        : 'spejdz' + commentId
                    : type == '2'
                        ? 'wzyjdz' + commentId
                        : 'wzejdz' + commentId
            self.$toast({
              duration: 2000,
              message: '点赞成功',
              context: this,
            })
          })
        }
      }
    },
    //二级评论点赞与取消点赞
    secondSupport: function (index, type, parentId, replyCrmId, commentId) {
      if (!this.isGoLogin) {
        // gio('track', 'hafovideopage_commentpopgreat',{'member_level':"未登录"});
        globalGoLogin()
      } else {
        if (this.secondFlag) return false
        this.secondFlag = true
        const {isLikes, likes, id} = this.commentAllList[index]
        let self = this
        if (isLikes) {
          sensors.track('Unsupport', {
            content_id: this.articalId,
            content_title: this.title,
            author: '',
            page_name: this.$route.meta.title,
            is_comment: true,
          })
          this.secondCancelLike(
              id,
              type,
              parentId,
              replyCrmId,
              commentId,
              function () {
                self.secondFlag = false
                self.commentAllList[index].likes -= 1
                if (likes < 0) {
                  self.commentAllList[index].likes = 0
                }
                self.commentAllList[index].isLikes = !isLikes
              }
          )
        } else {
          gio('track', 'comment_likecomment', {page_name: '评论详情'})
          sensors.track('Support', {
            content_id: this.articalId,
            content_title: this.title,
            author: '',
            page_name: this.$route.meta.title,
            is_comment: true,
          })
          // gio('track', 'hafovideopage_commentpopgreat',{'member_level':this.memberLevel.grade.name});
          this.secondAddLike(
              id,
              type,
              parentId,
              replyCrmId,
              commentId,
              function () {
                self.secondFlag = false
                self.commentAllList[index].likes += 1
                self.commentAllList[index].isLikes = !isLikes
                var relation =
                    self.carrierId == '1'
                        ? type == '2'
                            ? 'spyjdz' + id
                            : 'spejdz' + id
                        : type == '2'
                            ? 'wzyjdz' + id
                            : 'wzejdz' + id
                self.$toast({
                  duration: 2000,
                  message: '点赞成功',
                  context: this,
                })
              }
          )
        }
      }
    },
    // 点赞
    addLike: function (id, type, parentId, replyCrmId, commentId, callback) {
      // type 1 视频 2 一级评论 3 回复
      this.$http.post(
          this.$http.harvardBaseURL + '/like/add/ZBvOm0ocQSUykUX5',
          {},
          {
            carrierId: this.carrierId,
            carrierSpecificId: this.articalId,
            crmId: this.userInfo.crm_id,
            type: type,
            isRead: false,
            parentId: parentId,
            status: true,
            replyCrmId: replyCrmId,
            commentId: commentId,
          },
          (res) => {
            if (res.code == '200') {
              callback()
            }
          }
      )
    },
    // 取消点赞
    cancelLike: function (type, parentId, replyCrmId, commentId, callback) {
      // type 1 视频 2 一级评论 3 回复
      this.$http.post(
          this.$http.harvardBaseURL + '/like/cancel/ZBvOm0ocQSUykUX5',
          {},
          {
            carrierId: this.carrierId,
            carrierSpecificId: this.articalId,
            crmId: this.userInfo.crm_id,
            type: type,
            isRead: false,
            parentId: parentId,
            status: true,
            replyCrmId: replyCrmId,
            sourceId: 4,
            commentId: commentId,
          },
          (res) => {
            if (res.code == '200') {
              callback()
            }
          }
      )
    },
    // 二级点赞
    secondAddLike(num, type, parentId, replyCrmId, commentId, callback) {
      var nickName = this.getCookie('xmh_nickname')
      var headImg = this.getCookie('xmh_headimgurl')
      this.$http.post(
          this.$http.harvardBaseURL + '/like/add/ZBvOm0ocQSUykUX5',
          {},
          {
            carrierId: this.carrierId,
            carrierSpecificId: this.articalId,
            crmId: this.userInfo.crm_id,
            sourceId: 4,
            type: type,
            isRead: false,
            parentId: parentId,
            status: true,
            nickName: nickName,
            headImg: headImg,
            replyCrmId: replyCrmId,
            commentId: commentId,
          },
          (res) => {
            if (res.code == '200') {
              callback()
            }
          }
      )
    },
    // 二级取消点赞
    secondCancelLike(num, type, parentId, replyCrmId, commentId, callback) {
      this.$http.post(
          this.$http.harvardBaseURL + '/like/cancel/ZBvOm0ocQSUykUX5',
          {},
          {
            carrierId: this.carrierId,
            carrierSpecificId: this.articalId,
            crmId: this.userInfo.crm_id,
            sourceId: 4,
            type: type,
            isRead: false,
            parentId: parentId,
            status: true,
            replyCrmId: replyCrmId,
            commentId: commentId,
          },
          (res) => {
            if (res.code == '200') {
              callback()
            }
          }
      )
    },
    // 点击展开评论
    expandComment: function (event, handleType) {
      this.oneConH = parseInt($('.commentText').css('line-height')) * 3
      if (handleType == 1) {
        //展开
        $(event.target)
            .parents('.commentText')
            .css('max-height', 'initial')
        $(event.target)
            .parents('.commentText')
            .find('.openCon')
            .css('display', 'none')
        $(event.target)
            .parents('.commentText')
            .find('.closeCon')
            .css('display', 'block')
      } else {
        //收起
        $(event.target)
            .parents('.commentText')
            .css('max-height', this.oneConH + 'px')
        $(event.target)
            .parents('.commentText')
            .find('.openCon')
            .css('display', 'block')
        $(event.target)
            .parents('.commentText')
            .find('.closeCon')
            .css('display', 'none')
      }
      if (handleType == 3) {
        //展开
        $(event.target)
            .parents('.commentText')
            .css('max-height', 'initial')
        $(event.target)
            .parents('.commentText')
            .find('.openCon2')
            .css('display', 'none')
        $(event.target)
            .parents('.commentText')
            .find('.closeCon2')
            .css('display', 'block')
      } else if (handleType == 4) {
        //收起
        $(event.target)
            .parents('.commentText')
            .css('max-height', this.oneConH + 'px')
        $(event.target)
            .parents('.commentText')
            .find('.openCon2')
            .css('display', 'block')
        $(event.target)
            .parents('.commentText')
            .find('.closeCon2')
            .css('display', 'none')
      }
    },
    // 获取评论
    getAllComment: function (page, size, status) {
      var paramsPage = status == true ? page : this.commentParams.page
      var paramsSize = status == true ? size : this.commentParams.size
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.$http.post(
          this.$http.harvardBaseURL + '/comment/getAllReply/ZBvOm0ocQSUykUX5',
          {},
          {
            page: paramsPage,
            size: paramsSize,
            data: {
              id: this.firstComment,
              crmId: this.userInfo != null ? this.userInfo.crm_id : '',
            },
          },
          (res) => {
            this.listLoading = false
            if (res.code == '200') {
              this.commentTotal = res.data.pageBean.size
              this.firstComList = res.data
              const {content, size} = res.data.pageBean
              if (status) {
                // 添加评论
                this.commentAllList = []
                this.commentAllList = this.commentAllList.concat(content)
              } else {
                this.commentAllList = this.commentAllList.concat(content)
              }
              this.$nextTick(() => {
                let con2H = $('.commentText').find('.con2')[0].offsetHeight
                if (con2H > this.oneConH) {
                  $('.commentText')
                      .find('.openCon2')
                      .css('display', 'block')
                }
                if (this.commentAllList.length > 0) {
                  let commentLists = this.$refs.commentList.slice(
                          this.commentLen,
                          this.$refs.commentList.length
                      ),
                      that = this
                  $.each(commentLists, function (index, item) {
                    that.oneConH =
                        parseInt($('.commentText').css('line-height')) * 3
                    let conH = $(item).find('.con')[0].offsetHeight
                    if (conH > that.oneConH) {
                      $(item)
                          .find('.openCon')
                          .css('display', 'block')
                    }
                  })
                  this.commentLen = this.$refs.commentList.length - 1
                }
              })
              if (
                  paramsPage >= Math.ceil(size / paramsSize) ||
                  Math.ceil(size / paramsSize) <= 1
              ) {
                this.listFinished = true
                this.finishText = '——已经到底了哦——'
              } else {
                this.listFinished = false
                this.commentParams.page += 1
              }
            } else {
              this.listLoading = false
              this.listError = true
            }
          }
      )
    },
  },
}
</script>
